import React, { useState } from 'react';
import { Sparkles, Wand2 } from 'lucide-react';
import { useAIStatus } from './useAIStatus';
import { AIGenerateDialog } from './AIGenerateDialog';
import { AIImproveDialog } from './AIImproveDialog';

// Boutons IA à placer à côté d'un champ texte. Disparaît si l'IA est OFF ou l'utilisateur non connecté.
export const AIWriter = ({ api, field, context, value, onApply }) => {
  const status = useAIStatus(api);
  const [genOpen, setGenOpen] = useState(false);
  const [impOpen, setImpOpen] = useState(false);

  if (!api || !status?.enabled) return null;
  const hasText = Boolean((value || '').trim());

  return (
    <div className="flex flex-wrap items-center gap-2 mt-1" data-testid={`ai-writer-${field}`}>
      <button type="button" onClick={() => setGenOpen(true)} data-testid={`ai-generate-btn-${field}`}
        className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border border-primary/50 text-primary hover:bg-primary/10 transition-colors">
        <Sparkles className="w-3.5 h-3.5" /> Générer avec l'IA
      </button>
      {hasText && (
        <button type="button" onClick={() => setImpOpen(true)} data-testid={`ai-improve-btn-${field}`}
          className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border border-border text-muted-foreground hover:text-primary hover:border-primary/50 transition-colors">
          <Wand2 className="w-3.5 h-3.5" /> Améliorer
        </button>
      )}
      {typeof status.remaining === 'number' && (
        <span className="text-[10px] text-muted-foreground" data-testid={`ai-remaining-${field}`}>{status.remaining}/{status.quota} aujourd'hui</span>
      )}
      <AIGenerateDialog open={genOpen} onOpenChange={setGenOpen} api={api} field={field} context={context} onApply={onApply} />
      <AIImproveDialog open={impOpen} onOpenChange={setImpOpen} api={api} field={field} text={value} onApply={onApply} />
    </div>
  );
};
